if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.currentHandle = this.dataset.currentHandle;
        this.limit = parseInt(this.dataset.limit);
        this.slider = this.querySelector('slider-component');

        const data = localStorage.getItem(`theme:recently-viewed`);
        const all = JSON.parse(data) || [];
        // ETERNAL YOU: 리퍼브(B급) 상품은 '최근 본 상품'에서 제외하고 저장된 목록에서도 지운다
        this.list = all.filter((item) => !/-b-grade-/.test(item.handle || '') && !(item.element || '').includes('[REFURB]'));
        if (this.list.length !== all.length) {
          try { localStorage.setItem('theme:recently-viewed', JSON.stringify(this.list)); } catch (e) {}
        }
        this.container = this.querySelector('.slider-component__grid');
      }

      connectedCallback() {
        this.initializeRecommendations(this.dataset.productId);
      }

      initializeRecommendations() {
        const filteredList = this.list.filter((item) => item.handle !== this.currentHandle);
        if (Shopify.designMode !== true && filteredList.length === 0) return;
        if (Shopify.designMode === true && filteredList.length !== 0) this.container.innerHTML = '';
        filteredList.forEach((item, index) => {
          if (this.container.children.length >= this.limit) return;
          const wrapper = document.createElement('li');
          wrapper.setAttribute('id', `Slide-${this.sectionId}-${index}`);
          wrapper.classList.add('slider-component__item');
          wrapper.innerHTML = item.element;
          this.container.appendChild(wrapper);
        });
        this.style.setProperty('--count', this.container.children.length);
        this.removeAttribute('hidden');
        this.slider?.mount();
      }
    }
  );
}
